// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3f9507d7","732":"9acdf0df","977":"fcf60fc7"}[chunkId] + ".chunk.js";
};